module.exports = __webpack_public_path__ + "img/logo-dashboard-header-dark.7ae3b8da.png";